import React, { useEffect } from 'react';
import { useAlerts } from 'hooks/alerts-hooks';
import usePermissions from 'hooks/permissions-hooks';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import axiosClient from 'http/axios-client';
import * as _ from 'lodash';
import SearchBarForReport from 'components/basic/SearchBarForReports';
import { Grid } from '@material-ui/core';
import { roles } from '../../cassandra-shared-js/roles';

export const SearchAndFilterButtons = ({ setFilterQuery, filterQuery, reportType }) => {
  const { userHasRole, role, userHasRoleExact } = usePermissions();
  const { alertSuccess, alertError } = useAlerts();

  let roleApproval = '';

  if (userHasRole(roles.ANALYTICS_DEPARTMENT_USER_ROLE)) {
    roleApproval = 'analysis_approval';
  } else if (userHasRoleExact(roles.QUALITY_DEPARTMENT_USER_ROLE)) {
    roleApproval = 'third_party_approval';
  } else if (userHasRole(roles.THIRD_PARTY_CARDIOLOGIST)) {
    roleApproval = 'cardiologist_approval';
  } else if (userHasRole(roles.NUTRITION_GENETICS_USER)) {
    roleApproval = 'nutrition_geneticist_approval';
  } else if (userHasRoleExact(roles.QUALITY_DEPARTMENT_USER_ROLE_2)) {
    roleApproval = 'third_party_approval_2';
  }

  let realName = '';
  let approval = '';

  // Function for NOTIFY NEXT ROLE Button
  function notifyRequest(report) {
    switch (report) {
      case 'PGX':
        realName = 'iDNA PGx CNS Kit';
        approval = 'third_party_approval';
        break;

      case 'NG':
        realName = 'iDNA NutriGenetix kit';
        approval = 'nutrition_geneticist_approval';
        break;

      case '3IN1':
        realName = 'iDNA Test 3in1';
        approval = 'nutrition_geneticist_approval';
        break;

      case 'BIOAGE':
        realName = 'iDNA Biological Age';
        approval = 'analysis_approval';
        break;

      case 'CARDIO':
        realName = 'iDNA Cardio Health';
        approval = 'third_party_approval_2';
        break;

      case 'NUTRITION':
        realName = 'iDNA Nutrition Test';
        approval = 'nutrition_geneticist_approval';
        break;

      default:
        alertError('Notify Failed. This report does not exist');
        return;
    }

    if (userHasRoleExact(roles.ANALYTICS_DEPARTMENT_USER_ROLE)) {
      approval = 'analysis_approval';
    }

    axiosClient.post('mail/approval-notifications', {
      real_name: realName,
      approval,
    }).then(() => {
      alertSuccess('The notification has been successfully sent.');
    });
  }

  useEffect(() => {
    // we add the _where object bellow to have the VIEW PENDING as starting page
    setFilterQuery(
      { _where: {
        _or:
          [
            { [`${ roleApproval }_eq`]: false },
            { [`${ roleApproval }_null`]: true },
          ],
      },
      'serial_number_id.serial_contains': [ ],
      registrationStatus_ne: 'done' },
    );

    return (
      () => {
        setFilterQuery({});
      }
    );
  }, [ role ]);

  const isActive = (suffix, value) => {
    const key = `${ roleApproval }_${ suffix }`;

    return filterQuery?.[key] === value;
  };

  return (
    <Grid>
      <Grid style={ { paddingLeft: 50 } }>
        <div style={ { marginLeft: 'auto', height: 'fit-content' } }>
          <ButtonGroup style={ { gap: '5px', padding: '0', display: 'flex' } }>
            {
              (!userHasRole(roles.THIRD_PARTY_CARDIOLOGIST)) && (
                <Button
                  variant='contained'
                  style={ { marginRight: '3px' } }
                  onClick={ () => {
                    notifyRequest(reportType);
                  } }
                >
                  Notify next role
                </Button>
              )
            }

            <Button
              variant='contained'
              style={ { background: filterQuery?._where !== undefined ? '#0292b5' : '#00C0EF', color: 'white' } }
              onClick={ () => {
                setFilterQuery((data) => {
                  const otherKey = `${ roleApproval }_eq`;
                  const prev = _.cloneDeep(data);
                  const obj = {
                    ...prev,
                  };

                  obj._where = {
                    _or:
                    [
                      { [`${ roleApproval }_eq`]: false },
                      { [`${ roleApproval }_null`]: true },
                    ],
                  };

                  delete obj[otherKey];

                  obj.registrationStatus_ne = 'done';

                  return obj;
                });
              } }
            >
              View Pending
            </Button>
            <Button
              variant='contained'
              style={ { background: isActive('eq', true) ? '#0292b5' : '#00C0EF', color: 'white' } }
              onClick={ () => {
                setFilterQuery((data) => {
                  const key = `${ roleApproval }_eq`;

                  const prev = _.cloneDeep(data);
                  const obj = {
                    ...prev,
                    [key]: true,
                  };

                  delete obj.registrationStatus_ne;
                  delete obj._where;
                  return obj;
                });
              } }
            >
              View Approved
            </Button>
            <Button
              variant='contained'
              style={ { background: (_.isEqual(filterQuery, {}) || null == filterQuery || (!(`${ roleApproval }_eq` in filterQuery) && (filterQuery._where === undefined))) ? '#0292b5' : '#00C0EF', color: 'white' } }
              onClick={ () => {
                setFilterQuery((prev) => {
                  const key = `${ roleApproval }_eq`;

                  const obj = {
                    ...prev,
                  };

                  delete obj[key];
                  delete obj._where;
                  delete obj.registrationStatus_ne;

                  return obj;
                });
              } }
            >
              View All
            </Button>
          </ButtonGroup>
        </div>
      </Grid>
      <Grid style={ { padding: 20, paddingLeft: 50, paddingBottom: 1 } }>
        <SearchBarForReport setFilterQuery={ setFilterQuery } />
      </Grid>
    </Grid>
  );
};
